module.exports = __webpack_public_path__ + "img/error-hair.4defbb72.svg";